import { checkIfLoggedIn } from '@blaze-cms/core-auth-ui';

const getRecordId = (entityForQuery, dataRecordId, parent) => {
  const [recordId] = dataRecordId;
  let foundUserId;

  if (entityForQuery === 'user' && !recordId) {
    const { id: userId } = checkIfLoggedIn();
    foundUserId = userId;
  }
  return foundUserId || recordId || (parent && parent.itemId);
};

export default getRecordId;
